import React, {useEffect, useState} from 'react';
import {useNavigate, useOutletContext} from "react-router-dom";

import styles from './InfoAboutCustomerPage.module.scss';
import NewCustomer from "../../../components/NewCustomer/NewCustomer";
import RegularCustomer from "../../../components/RegularCustomer/RegularCustomer";
import {MAIN_ROUTES} from "../../../routing/main_routes";

const InfoAboutCustomerPage = ({setCurrentStep}) => {
    const [selectedOption, setSelectedOption] = useState('Я новий замовник');
    const {error, setError} = useOutletContext();

    const handleSelectOption = (option) => {
        setSelectedOption(option);
    }

    const currentStep = JSON.parse(localStorage.getItem('currentStep'));
    const navigate = useNavigate();


    useEffect(() => {
        if (currentStep !== 5) {
            navigate(MAIN_ROUTES.CREATE_ORDER);
        }
    }, []);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }, []);

    return (
        <div className={styles.InfoAboutCustomerPage}>
            <div className={styles.InfoAboutCustomerPage_options}>
                <button
                    className={`${styles.InfoAboutCustomerPage_options_item} 
                    ${selectedOption === 'Я новий замовник' ? styles.active : ''}`}
                    onClick={() => handleSelectOption('Я новий замовник')}
                >Я новий замовник
                </button>
                <button
                    className={`${styles.InfoAboutCustomerPage_options_item} 
                    ${selectedOption === 'Я постійний клієнт' ? styles.active : ''}`}
                    onClick={() => handleSelectOption('Я постійний клієнт')}
                >Я постійний клієнт
                </button>
            </div>

            {
                selectedOption === 'Я новий замовник' ?
                    <NewCustomer error={error} setError={setError} setCurrentStep={setCurrentStep}/> :
                    <RegularCustomer error={error} setError={setError} setCurrentStep={setCurrentStep} />
            }
        </div>
    );
};

export default InfoAboutCustomerPage;
